export default __webpack_public_path__ + "images/ae4ab1267fa0cafc37ae5f4b5c41e3e7.png";